'use strict';
var extendFlags,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

extendFlags = function() {
  var bodyClasses, ref, ref1;
  bodyClasses = document.body.classList || $(document.body).getClasses();
  return Object.assign(window.Groupon, {
    App: {
      name: $(document.head).attr('data-app')
    },
    Browsers: {
      chrome: !!window.chrome,
      phantomJS: !!(window._phantom || window.callPhantom),
      safari: ((ref = navigator.vendor) != null ? ref.indexOf('Apple') : void 0) > -1 && !((ref1 = navigator.userAgent) != null ? ref1.match('CriOS') : void 0)
    },
    PageFlags: {
      isWeb: indexOf.call(bodyClasses, 'is-web') >= 0,
      isTouch: indexOf.call(bodyClasses, 'is-touch') >= 0,
      isLegacyResponsive: indexOf.call(bodyClasses, 'ls-resp') >= 0,
      isTouchRedesign: indexOf.call(bodyClasses, 't-redesign') >= 0,
      isTouchRequest: indexOf.call(bodyClasses, 'is-touch-request') >= 0
    }
  });
};

module.exports = function() {
  if (document.body != null) {
    return extendFlags();
  } else {
    return $(function() {
      return extendFlags();
    });
  }
};

